<template>
  <div class="allocation-card border rounded-3">
    <slot name="leftLabel">
      <p class="m-0">{{ props.leftLabel }}</p>
    </slot>
    <slot name="rightLabel">
      <p class="m-0 text-muted">{{ props.rightLabel }}</p>
    </slot>
  </div>
</template>
<script setup lang="ts">
const props = defineProps<{
  leftLabel?: string;
  rightLabel?: string;
}>();
</script>
<style scoped>
.allocation-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  font-weight: bold;
}
</style>
